import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_automation_revalidate_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { queryClient } from '@/services/reactQuery.ts';
import { AUTOMATION_LATEST_VERSION_KEY } from '@/utils/queryKeys.ts';
import { SimpleResponse } from '@/types/common.ts';

const useRevalidateAutomation = (): UseMutationResult<SimpleResponse, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.put(get_automation_revalidate_url(automationId));
      await queryClient.invalidateQueries({
        queryKey: AUTOMATION_LATEST_VERSION_KEY(automationId),
      });

      return response.data;
    },
  });
};

export default useRevalidateAutomation;
